import { render, staticRenderFns } from "./GeneralSettingsPage.vue?vue&type=template&id=3ed2529a&"
import script from "./GeneralSettingsPage.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports